'use client';

import { createToaster } from '@chakra-ui/react';

const toaster = createToaster({
  placement: 'top-end',
  duration: 5000,
});

export default function useToast() {
  return toaster.create;
}
